<template>
  <div class="spiner"></div>
</template>

<script>

export default {
name: "spinner",
mounted(){
    console.log("pp");
}
}

</script>

<style >
div.spiner{
    width: 4rem;
    height: 4rem;
    border-top: 2px solid var(--VeryDarkBlue);
    animation: 1s spinner infinite linear;
    margin: 6rem auto;
    border-radius: 50%;
}
@keyframes spinner{
0% {
    transform: rotate(0deg);
}
100% {
    transform: rotate(360deg);
}
}
</style>